<template>
  <div class="py-10 bg-gray-100 min-h-screen flex flex-col items-center">
    <div class="w-full prose font-medium px-2 text-justify tracking-tight" style="max-width: 75ch">
      <h3>
        PLEASE READ THE TERMS OF THIS POLICY CAREFULLY BEFORE USING THE CLINICAL EXPERIENCES (CE)
        PORTAL
      </h3>
      <div>
        <h4>What's in these terms?</h4>
        <p>
          This acceptable use policy sets out the content standards that apply when you access, use
          or interact in any way with Clinical Experiences (“CE”) (the “Software”).
        </p>
        <h4>By using our site you accept these terms</h4>
        <p>
          By using the Software, you confirm that you accept the terms of this policy and that you
          agree to comply with them.
        </p>
        <p>If you do not agree to these terms you must not access or use the Software.</p>
      </div>
      <p>
        All personal data processed by us as a result of your access or use of the Software will be
        handled in accordance with our Privacy Policy.
      </p>
      <div>
        <h4>Registration</h4>
        <p>
          You may be required to provide information about yourself in order to register for and/or
          use the Software. You agree that any such information shall be accurate. You may also be
          asked to choose a user name and password. You are entirely responsible for maintaining the
          security of Your user name and password and agree not to disclose such to any third party.
        </p>
        <h4>We may make changes to the terms of this policy</h4>
        <p>
          We amend these terms from time to time by notification to you. Every time you wish to
          access or use the Software, the latest version of our terms will apply to your access and
          use. These terms were most recently updated on 15th December 2022.
        </p>
        <h4>Prohibited uses</h4>
        <p>You may not use the Software:</p>
        <ul>
          <li>
            In any way that breaches any applicable local, national or international law or
            regulation.
          </li>
          <li>
            In any way that is unlawful or fraudulent or has any unlawful or fraudulent purpose or
            effect.
          </li>
          <li>For the purpose of harming or attempting to harm minors in any way.</li>
          <li>To bully, insult, intimidate or humiliate any person.</li>
          <li>
            To send, knowingly receive, upload, download, use or re-use any material which does not
            comply with our content standards listed below.
          </li>
          <li>
            To transmit, or procure the sending of, any unsolicited or unauthorised advertising or
            promotional material or any other form of similar solicitation (spam).
          </li>
          <li>
            To knowingly transmit any data, send or upload any material that contains viruses,
            Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other
            harmful programs or similar computer code designed to adversely affect the operation of
            any computer software or hardware.
          </li>
          <li>To upload or transmit terrorist content.</li>
        </ul>
        <h4>You also agree:</h4>
        <ul>
          <li>
            not to duplicate, reproduce, resell, or distribute the Software or any reports or data
            generated by the Software for any purpose unless you have been specifically permitted to
            do so under a separate written agreement with us. You may not offer or enable any third
            parties to use the Software, display on any website or otherwise publish the Software or
            any content thereon obtained from the Software (other than content created by you) or
            otherwise
          </li>
          <li>
            <ul>
              Not to access without authority, interfere with, damage or disrupt:
              <li>any part of our site;</li>
              <li>any equipment or network on which our site is stored;</li>
              <li>any software used in the provision of our site; or</li>
              <li>any equipment or network or software owned or used by any third party.</li>
            </ul>
          </li>
        </ul>
        <h4>Interactive services</h4>
        <p>
          We may from time to time provide interactive services on our site, including, without
          limitation:
        </p>
        <ul>
          <li>Video-sharing and streaming facilities, both as a viewer and a contributor</li>
          <li>Chat rooms.</li>
          <li>Bulletin boards.</li>
        </ul>
        (
        <strong>interactive services.</strong>
        )
        <p>
          Where we do provide any interactive service, we will provide clear information to you
          about the kind of service offered, if it is moderated and what form of moderation is used
          (including whether it is human or technical).
        </p>
        <p>
          We will do our best to assess any possible risks for users from third parties when they
          use any interactive service provided on our site, and we will decide in each case whether
          it is appropriate to use moderation of the relevant service (including what kind of
          moderation to use) in the light of those risks. However, we are under no obligation to
          oversee, monitor or moderate any interactive service we provide on our site, and we
          expressly exclude our liability for any loss or damage arising from the use of any
          interactive service by a user in contravention of our content standards, whether the
          service is moderated or not.
        </p>
        <p>
          We advise parents who permit their children to use an interactive service that it is
          important that they communicate with their children about their safety online, as
          moderation is not fool proof. Minors who are using any interactive service should be made
          aware of the potential risks to them.
        </p>
        <p>
          Where we do moderate an interactive service, we will normally provide you with a means of
          contacting the moderator, should a concern or difficulty arise.
        </p>
        <p>
          To the extent that your use of the Software includes the recording of content, you are
          responsible for compliance will all recording laws. The host may opt to record meetings or
          sessions online. By using the Software, you are give the host consent to store any such
          recordings for any or all meetings or sessions that you join, if such recordings are
          stored in their systems and consent to the streaming of your video to end users, to
          transcode or compress your video for viewing optimisation purposes, to generate stills
          from your video, to automatically generate and display closed captions or subtitles from
          your video or to alter or enhance your video as directed or selected by you. You will
          receive a notification (visual or otherwise) when recording is enabled. If you do not
          consent to being recorded, you can choose to leave the meeting or session. The permissions
          granted by you under this paragraph (a) are granted on a non-exclusive, worldwide and
          royalty-free basis; (b) include the right and license to copy, use, distribute, publicly
          perform, and display the licensed work for the purposes stated above; and (c) include all
          necessary rights and licenses to allow us and any host to exercise their rights and
          perform its obligations. By granting these rights, you waive any so-called “moral rights”
          that you may have. Nothing in this Agreement shall be deemed a license “condition”
          applicable to us or any host; rather, any breach of a term by us hereof shall give rise
          to, at most, a claim for breach of contract only.
        </p>
        <h4>Content standards</h4>
        <p>
          These content standards apply to any and all material which you contribute to the Software
          (
          <strong>Contribution</strong>
          ), and to any interactive services associated with it.
        </p>
        <p>
          The Content Standards must be complied with in spirit as well as to the letter. The
          standards apply to each part of any Contribution as well as to its whole.
        </p>
        <p>
          Global Health Education Group Limited will determine, in its discretion, whether a
          Contribution breaches the Content Standards.
        </p>
        <p>A Contribution must:</p>
        <ul>
          <li>Be accurate (where it states facts).</li>
          <li>Be genuinely held (where it states opinions).</li>
          <li>
            Comply with the law applicable in England and Wales and in any country from which it is
            posted.
          </li>
        </ul>
        <p>A Contribution must not:</p>
        <ul>
          <li>Be defamatory of any person.</li>
          <li>Be obscene, offensive, hateful or inflammatory.</li>
          <li>Bully, insult, intimidate or humiliate.</li>
          <li>Promote sexually explicit material.</li>
          <li>Include child sexual abuse material.</li>
          <li>Promote violence.</li>
          <li>
            Promote discrimination based on race, sex, religion, nationality, disability, sexual
            orientation or age.
          </li>
          <li>Infringe any copyright, database right or trade mark of any other person.</li>
          <li>Be likely to deceive any person.</li>
          <li>
            Breach any legal duty owed to a third party, such as a contractual duty or a duty of
            confidence.
          </li>
          <li>Promote any illegal content or activity.</li>
          <li>Be in contempt of court.</li>
          <li>
            Be threatening, abuse or invade another's privacy, or cause annoyance, inconvenience or
            needless anxiety.
          </li>
          <li>Be likely to harass, upset, embarrass, alarm or annoy any other person.</li>
          <li>
            Impersonate any person or misrepresent your identity or affiliation with any person.
          </li>
          <li>
            Give the impression that the Contribution emanates from Global Health Education Group
            Limited, if this is not the case.
          </li>
          <li>
            Advocate, promote, incite any party to commit, or assist any unlawful or criminal act
            such as (by way of example only) copyright infringement or computer misuse.
          </li>
          <li>
            Contain a statement which you know or believe, or have reasonable grounds for believing,
            that members of the public to whom the statement is, or is to be, published are likely
            to understand as a direct or indirect encouragement or other inducement to the
            commission, preparation or instigation of acts of terrorism.
          </li>
          <li>Contain any advertising or promote any services or web links to other sites.</li>
        </ul>
        <p>For the avoidance of doubt, for any Contribution in the form of video content:</p>
        <ul>
          <li>
            You must tell us immediately, if you upload a video containing any of the following:
            criminal material (relating to terrorism, sexual exploitation of children, child
            pornography, racism and xenophobia), unclassified or unclassifiable videos, videos rated
            R18 or suitable for R18 rating and other material that might impair the physical, mental
            or moral development of persons under the age of 18 (restricted material).
          </li>
          <li>You must not upload a video containing harmful material.</li>
          <li>
            You must not upload a video containing advertising for any of the following:
            <ul>
              <li>
                cigarettes and other tobacco products, electronic cigarettes or electronic cigarette
                refill containers, and prescription-only medicine; or
              </li>
              <li>
                for alcoholic drinks that are not aimed specifically at under 18s and do not
                encourage immoderate consumption of alcohol.
              </li>
            </ul>
          </li>
          <li>
            Any advertising included in a video you upload must not:
            <ul>
              <li>prejudice respect for human dignity;</li>
              <li>
                include or promote discrimination based on sex, racial or ethnic origin,
                nationality, religion or belief, disability, age or sexual orientation;
              </li>
              <li>encourage behaviour prejudicial to health or safety;</li>
              <li>encourage behaviour grossly prejudicial to the protection of the environment;</li>
              <li>cause physical, mental or moral detriment to persons under the age of 18;</li>
              <li>
                directly exhort such persons to purchase or rent goods or services in a manner which
                exploits their inexperience or credulity;
              </li>
              <li>
                directly encourage such persons to persuade their parents or others to purchase or
                rent goods or services;
              </li>
              <li>exploit the trust of such persons in parents, teachers or others; or</li>
              <li>unreasonably show such persons in dangerous situations.</li>
            </ul>
          </li>
          <li>
            You must use the functionality provided on the Software to declare whether, as far as
            you know or can reasonably be expected to know, any video contains advertising.
          </li>
        </ul>

        <h4>Breach of this policy</h4>
        <p>
          When we consider that a breach of this acceptable use policy has occurred, we may take
          such action as we deem appropriate.
        </p>
        <p>
          Failure to comply with this acceptable use policy constitutes a material breach of the
          terms of use upon which you are permitted to use our site, and may result in our taking
          all or any of the following actions:
        </p>
        <ul>
          <li>Immediate, temporary or permanent withdrawal of your right to use our site.</li>
          <li>
            Immediate, temporary or permanent removal of any Contribution uploaded by you to our
            site.
          </li>
          <li>Issue of a warning to you.</li>
          <li>
            Legal proceedings against you for reimbursement of all costs on an indemnity basis
            (including, but not limited to, reasonable administrative and legal costs) resulting
            from the breach.
          </li>
          <li>Further legal action against you.</li>
          <li>
            Disclosure of such information to law enforcement authorities as we reasonably feel is
            necessary or as required by law.
          </li>
        </ul>
        <p>
          We exclude our liability for all action we may take in response to breaches of this
          acceptable use policy. The actions we may take are not limited to those described above,
          and we may take any other action we reasonably deem appropriate.
        </p>
        <h4>How this contract can be transferred</h4>
        <p>
          We can transfer our rights and obligations under these terms to any third party, provided
          this does not adversely affect your rights under these terms.
        </p>
        <h4>Which country's laws apply to any disputes?</h4>
        <p>
          The terms of this policy, its subject matter and its formation (and any non-contractual
          disputes or claims) are governed by English law. You agree to the exclusive jurisdiction
          of the courts of England and Wales.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>
